import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { pageUrl } from '../seo'

const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
}

const PAGE_BG = {
    backgroundImage: `url(/assets/images/rapariga-scaled.png)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
}


export default function Direitos() {
    const { t } = useTranslation()
    const rights = t('direitos.itens', { returnObjects: true })
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="min-h-screen"
            style={PAGE_BG}
        >
            <title>{t('direitos.metaTitle')}</title>
            <meta name="description" content={t('direitos.metaDescription')} />
            {/* pageUrl() já inclui a base da língua (/, /en/, /uk/, …) */}
            <link rel="canonical" href={pageUrl('direitos')} />
            <meta property="og:url" content={pageUrl('direitos')} />
            {/* Hero */}
            <section className="py-16 lg:py-24" style={{ backgroundColor: '#00203F' }}>
                <div className="container-custom">
                    <motion.h1
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        className="font-heading text-4xl lg:text-5xl font-bold text-white leading-tight"
                    >
                        {t('direitos.heroTitle')}
                    </motion.h1>
                    <div className="mt-6 h-1 w-24 rounded-full" style={{ backgroundColor: '#ADEFD1' }} />
                </div>
            </section>

            {/* Content — high-opacity white for readability */}
            <section className="section-padding" style={{ backgroundColor: 'rgba(255,255,255,0.95)' }}>
                <div className="container-custom">
                    <motion.div
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="max-w-4xl mx-auto space-y-10"
                    >
                        {/* Intro */}
                        <div className="leading-relaxed space-y-4 text-base" style={{ color: '#00203F' }}>
                            <p>{t('direitos.introP1')}</p>
                            <div>
                                <a
                                    href="https://www.infovitimas.pt/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-block hover:opacity-80 transition-opacity"
                                >
                                    <img
                                        src="https://i0.wp.com/apav.pt/wp-content/uploads/2025/05/INFOVitimas.png?fit=300%2C52&ssl=1"
                                        alt={t('direitos.infovitimasAlt')}
                                        width="300"
                                        height="52"
                                    />
                                </a>
                            </div>
                            <p>{t('direitos.introP2')}</p>
                            <p className="font-bold text-base" style={{ color: '#00203F' }}>{t('direitos.listaTitulo')}</p>
                        </div>

                        {/* Rights list */}
                        <div className="space-y-4">
                            {rights.map((right, i) => (
                                <motion.div
                                    key={i}
                                    variants={fadeUp}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.4, delay: i * 0.06 }}
                                    className="flex gap-4 rounded-2xl p-5"
                                    style={{ backgroundColor: '#ffffff', border: '1px solid rgba(233,12,12,0.15)', boxShadow: '0 2px 8px rgba(0,32,63,0.06)' }}
                                >
                                    {/* Red accent dot */}
                                    <div className="shrink-0 mt-1">
                                        <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#E90C0C' }} />
                                    </div>
                                    <div className="space-y-2">
                                        <p className="font-bold text-base leading-snug" style={{ color: '#E90C0C' }}>{right.titulo}</p>
                                        {right.corpo?.map((para, j) => (
                                            <p key={j} className="leading-relaxed text-base" style={{ color: '#00203F' }}>{para}</p>
                                        ))}
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </section>
        </motion.div>
    )
}
